@if (password && passwordConditions && isEditMode) {
    <app-password-conditions [password]="value() || ''" />
}
<app-input-label
    [label]="label"
    [labelPosition]="labelPosition"
    [for]="id"
    [isRequired]="isRequired"
    [isEditMode]="isEditMode"
    [characterCount]="characterCount"
    [focused]="focused()">
    @if (isEditMode) {
        <kendo-textbox
            [type]="password && !showPassword() ? 'password' : 'text'"
            [title]="title | translate"
            [placeholder]="placeholder | translate"
            [maxlength]="maxLength"
            [minlength]="minLength"
            [disabled]="isDisabled"
            [ngClass]="generateInputStyle()"
            [(ngModel)]="value"
            (valueChange)="onValueChange($event)"
            (inputFocus)="onFocusIn()"
            (inputBlur)="onFocusOut()"
            (keypress)="onKeyPress($event)">
            <ng-template kendoTextBoxSuffixTemplate>
                @if (password) {
                    <button
                        class="group flex items-center justify-center rounded px-2"
                        type="button"
                        [attr.aria-label]="showPassword() ? 'Hide password' : 'Show password'"
                        [title]="showPassword() ? 'Hide password' : 'Show password'"
                        (click)="togglePasswordVisibility()">
                        <ng-icon
                            class="text-base text-muted group-hover:text-foreground"
                            [name]="showPassword() ? 'faSolidEyeSlash' : 'faSolidEye'"></ng-icon>
                    </button>
                }
                <ng-content select=".textbox-suffix"></ng-content>
            </ng-template>
        </kendo-textbox>
    } @else {
        @if (route) {
            <div class="pb-1 pt-1.5" kendoTooltip position="top" [title]="value()">
                <a [routerLink]="route.join('/')" (click)="clickedLink.emit(route)">
                    {{ value() }}
                </a>
            </div>
        } @else {
            <div class="pb-1 pt-1.5" kendoTooltip position="top" [title]="value()">
                {{ value() }}
            </div>
        }
    }
</app-input-label>
